import React, { ReactElement } from "react";
import { QualityHubTasksListEditBarProps } from './QualityHubTasksListEditBar.types';
import { DefaultButton, PrimaryButton, Toggle } from "@fluentui/react";
import { localize } from "src/l10n";
import "./QualityHubTasksListEditBar.scss";
import { Conditional } from "src/components/Conditional";

/**
 * Renders the edit bar for the QualityHubTasksList component.
 *
 * @param {QualityHubTasksListEditBarProps} props - The component props
 * @returns {ReactElement | null} The rendered component
 */
function QualityHubTasksListEditBar({
    hideDisabledItems,
    onAddNewTask,
    onAddNewGroupClicked,
    onCancel,
    onHideDisabledItemsChange,
    onSave,
}: QualityHubTasksListEditBarProps): ReactElement | null {
    return (
        <div className="QualityHubTasksListEditBar">
            <Conditional condition={!!onHideDisabledItemsChange}>
                <Toggle 
                    label={localize("HIDE_DISABLED_ITEMS")} 
                    inlineLabel 
                    checked={hideDisabledItems}
                    onChange={(_, checked) => onHideDisabledItemsChange?.(checked ?? false)}
                />
            </Conditional>
            <Conditional condition={!!onAddNewGroupClicked}>
                <PrimaryButton 
                    text={localize("ADD_GROUP")}
                    onClick={onAddNewGroupClicked}
                    iconProps={{ iconName: 'Add' }}
                />
            </Conditional>
            <Conditional condition={!!onAddNewTask}>
                <PrimaryButton 
                    text={localize("ADD_TASK")}
                    onClick={onAddNewTask}
                    iconProps={{ iconName: 'Add' }}
                />
            </Conditional>
            <Conditional condition={!!onCancel && !!onSave}>
                <DefaultButton text={localize("Avbryt")} onClick={onCancel} />
                <PrimaryButton text={localize("Spara")} onClick={onSave} />
            </Conditional>
        </div>
    );
}

export default QualityHubTasksListEditBar;

